import { StyleSheet } from 'react-native';
import { fontFamily } from '../../../constants/palette';

export default StyleSheet.create({
  containerColumn: {
    flexDirection: 'column',
    alignItems: 'center',

  },
  containerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
  }
});
